import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

export const pando3D = {
  container: null,
  grid: null,
  containerVectors: null,
  scene: null,
  camera: null,
  renderer: null,
  stats: null,
  controls: null,
  data: null,
  texture: null,
  truck: null,
  materialColors: {},
  materialScenes: [],
  config: {
    elementID: 'pando-3d',
    elementSection: '3d-section',
    elementToolTip: 'tip-3d',
  },

  initialize: () => {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const viewAngle = 30;
    const aspect = screenWidth / screenHeight;
    const NEAR = 0.1;
    const FAR = 20000;

    pando3D.scene = new THREE.Scene();
    pando3D.camera = new THREE.PerspectiveCamera(viewAngle, aspect, NEAR, FAR);
    pando3D.scene.add(pando3D.camera);

    pando3D.camera.position.x = pando3D.containerVectors.width * 2;
    pando3D.camera.position.y = pando3D.containerVectors.height * 2;
    pando3D.camera.position.z = pando3D.containerVectors.length * 2;
    pando3D.camera.lookAt(pando3D.scene.position);

    // pando3D.camera = new THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 0.1, 100);
    // pando3D.camera.position.set(4.25, 1.4, -4.5);
    // pando3D.scene.add(pando3D.camera);


    const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444);
    hemiLight.position.set(0, 20, 0);
    pando3D.scene.add(hemiLight);
    const dirLight = new THREE.DirectionalLight(0xffffff);
    dirLight.position.set(-3, 10, -10);
    dirLight.castShadow = true;
    dirLight.shadow.camera.top = 2;
    dirLight.shadow.camera.bottom = -2;
    dirLight.shadow.camera.left = -2;
    dirLight.shadow.camera.right = 2;
    dirLight.shadow.camera.near = 0.1;
    dirLight.shadow.camera.far = 40;
    pando3D.scene.add(dirLight);


    pando3D.renderer = new THREE.WebGLRenderer({ antialias: true });
    pando3D.renderer.setSize(screenWidth, screenHeight);
    pando3D.container = document.getElementById(pando3D.config.elementID);
    pando3D.container.appendChild(pando3D.renderer.domElement);
    pando3D.controls = new OrbitControls(pando3D.camera, pando3D.renderer.domElement);
    const canvas = document.querySelector(`#${pando3D.config.elementID} canvas`);
    pando3D.controls.maxDistance = canvas.offsetWidth * 2;

    pando3D.renderer.setPixelRatio(window.devicePixelRatio);
    pando3D.renderer.outputEncoding = THREE.sRGBEncoding;
    pando3D.container.appendChild(pando3D.renderer.domElement);
    pando3D.controls.enableDamping = true;
    // pando3D.controls.target.set(0, 0.5, 0);
    pando3D.controls.update();
    pando3D.scene.background = new THREE.Color(0xffffff);
    pando3D.scene.environment = new RGBELoader().load('/static/textures/venice_sunset_1k.hdr');


    // model
    const loader = new GLTFLoader();
    loader.load('/static/models/scene.gltf', (gltf) => {
      pando3D.truck = gltf.scene;
      pando3D.scene.add(pando3D.truck);
      pando3D.truck.scale.set(12, 12, 12);
      pando3D.truck.rotation.y += Math.PI + 19.8;
      pando3D.truck.position.y -= 195;
      pando3D.truck.position.z -= 170;
      pando3D.truck.visible = pando3D.data.showTruck;
      pando3D.truck.traverse((child) => {
        // if ( child.isMesh ) {
        child.geometry.center(); // center here
        child.material.opacity = 0.5;
        child.material.transparent = true;
        // }
      });

      pando3D.render();
    });
    console.log('===========>', pando3D.scene);

    pando3D.scene.environment.mapping = THREE.EquirectangularReflectionMapping;
    pando3D.setbaseTooltip();
  },
  changeTruckState: (visibility) => {
    pando3D.truck.visible = visibility;
  },
  resetData: (data) => {
    pando3D.data = data;
    pando3D.update();
  },
  animate: () => {
    window.requestAnimationFrame(pando3D.animate);
    pando3D.render();
    pando3D.update();
  },

  render: () => {
    pando3D.renderer.render(pando3D.scene, pando3D.camera);
  },

  update: () => {
    pando3D.controls.update();
  },

  setbaseTooltip: () => {
    document.addEventListener('mousemove', onDocumentMouseMove, false);
  },
};


const onDocumentMouseMove = (event) => {
  const mouse = new THREE.Vector2();
  const raycaster = new THREE.Raycaster();
  const canvas = document.querySelector(`#${pando3D.config.elementID} canvas`);

  mouse.x = ((event.offsetX / canvas.clientWidth) * 2) - 1;
  mouse.y = -((event.offsetY / canvas.clientHeight) * 2) + 1;

  raycaster.setFromCamera(mouse, pando3D.camera);
  const intersects = raycaster.intersectObjects(pando3D.scene.children);
  const tooltip = document.getElementById(pando3D.config.elementToolTip);
  const visualizeSection = document.getElementById(pando3D.config.elementSection);
  let html = '';

  if (intersects[0]) {
    if (intersects[0].object.name) {
      html += `${intersects[0].object.ref_id_text} <br />`;
      html += `${intersects[0].object.material_code} <br />`;
      html += intersects[0].object.name;

      tooltip.innerHTML = html;
      tooltip.style.visibility = 'visible';
      const topAdjustment = window.pageYOffset + visualizeSection.getBoundingClientRect().top;
      tooltip.style.top = `${event.clientY - topAdjustment}px`;
      tooltip.style.left = `${event.clientX + 25}px`;
      tooltip.style.background = '#f8f8f8';
      tooltip.style.boxShadow = '0 0 10px 0 rgba(0, 0, 0, 0.5)';
      tooltip.style.fontWeight = 'bold';
      tooltip.style.color = '#000000';
      tooltip.style.padding = '5px';
      tooltip.style.lineHeight = '1.5';
      tooltip.style.zindex = '1000000';
    } else {
      tooltip.style.visibility = 'hidden';
    }
  } else {
    tooltip.style.visibility = 'hidden';
  }
};

export default pando3D;
